export default __webpack_public_path__ + "static/media/img2.557476c6.png";